import React from 'react'
import { ContentHeader } from '../../../../../layout/Content'

function OutOfStockHeader() {
  return ( <ContentHeader title='Out Of Stocks' /> )
}

export default React.memo(OutOfStockHeader)
